export default {
  restaurantbanner: {
    subtitle: "للمطاعم",

    title1: "اطلب بذكاء.",
    title2: "أنفق أقل.",

    desc:
      "MAHAL هي منصة B2B لتوريد الأغذية تساعد المطاعم على التواصل مع الموردين الموثوقين وإدارة الطلبات والتحكم في المشتريات — كل ذلك من مكان واحد.",

    cta: "ابدأ الطلب",
  },
};